var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.4082 10.7549L31.6691 2.46465C31.2438 1.85149 30.6784 1.34853 30.0199 0.997442C29.3614 0.646355 28.6287 0.457251 27.8825 0.445801L16.9912 0.289551H16.9688C11.3458 0.289551 7.03154 1.23008 4.25293 5.82021C1.66602 10.0929 0.5625 17.3711 0.5625 30.1562V31.7187H4.13252L1.83438 43.4375C9.59355 43.4375 18.0602 43.4375 29.3954 43.4375L29.4605 33.0378L39.0992 31.3874C41.2828 31.1189 42.8938 30.4152 44.0236 29.2367C44.9895 28.2291 45.5772 26.9418 45.9298 25.0617L47.4375 17.0202V12.4264L37.4082 10.7549Z",
    fill: "#112025"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.5d52ded258a6f5edcc321d22bcc91633.svg";
export { ForwardRef as ReactComponent };